import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@/lib/router-compat";
import { homeBlogQueryOptions } from "@/lib/homeQueries";

const BlogCardImage = ({ src, alt }: { src: string | null; alt: string }) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return <div className="aspect-video w-full bg-muted/30" aria-hidden="true" />;
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      width={600}
      height={338}
      onError={() => setFailed(true)}
      className="aspect-video w-full bg-muted/30 object-cover"
    />
  );
};

export const HomeBlogSection = () => {
  const { data: posts = [] } = useQuery(homeBlogQueryOptions());
  if (posts.length === 0) return null;

  return (
    <section className="py-12 bg-background" aria-labelledby="home-blog">
      <div className="container">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <h2 id="home-blog" className="font-display text-2xl md:text-3xl font-bold">Últimas do blog</h2>
          <Link to="/blog-news" className="text-sm font-semibold text-link underline underline-offset-4">Ver todas as publicações</Link>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {posts.map((p) => (
            <article key={p.id} className="min-w-0 overflow-hidden rounded-lg border bg-card">
              <Link to={`/${p.slug}`} className="block">
                <BlogCardImage src={p.featured_image_url} alt={p.title} />
                <div className="p-4">
                  <h3 className="line-clamp-2 font-semibold">{p.title}</h3>
                  {p.excerpt && <p className="mt-2 line-clamp-2 text-sm text-muted-foreground">{p.excerpt}</p>}
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
